"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLAN_PRICING = exports.PLAN_LIMITS = exports.SubscriptionStatus = exports.SubscriptionPlan = void 0;
var SubscriptionPlan;
(function (SubscriptionPlan) {
    SubscriptionPlan["FREE"] = "FREE";
    SubscriptionPlan["PROFESSIONAL"] = "PROFESSIONAL";
    SubscriptionPlan["ENTERPRISE"] = "ENTERPRISE";
})(SubscriptionPlan || (exports.SubscriptionPlan = SubscriptionPlan = {}));
var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["ACTIVE"] = "ACTIVE";
    SubscriptionStatus["TRIALING"] = "TRIALING";
    SubscriptionStatus["PAST_DUE"] = "PAST_DUE";
    SubscriptionStatus["CANCELED"] = "CANCELED";
    SubscriptionStatus["PAUSED"] = "PAUSED";
})(SubscriptionStatus || (exports.SubscriptionStatus = SubscriptionStatus = {}));
exports.PLAN_LIMITS = {
    [SubscriptionPlan.FREE]: {
        organizations: 1,
        projects: 5,
        scansPerMonth: 10,
        apiCallsPerDay: 0,
        features: {
            bulkUpload: false,
            apiAccess: false,
            customSchedules: false,
            prioritySupport: false,
            whiteLabel: false,
            sso: false,
            onPremise: false,
            advancedCompliance: false,
            emailAlerts: false,
            historicalAnalysis: false,
        },
    },
    [SubscriptionPlan.PROFESSIONAL]: {
        organizations: 5,
        projects: -1, // unlimited
        scansPerMonth: 100,
        apiCallsPerDay: 10000,
        features: {
            bulkUpload: true,
            apiAccess: true,
            customSchedules: true,
            prioritySupport: true,
            whiteLabel: false,
            sso: false,
            onPremise: false,
            advancedCompliance: true,
            emailAlerts: true,
            historicalAnalysis: true,
        },
    },
    [SubscriptionPlan.ENTERPRISE]: {
        organizations: -1, // unlimited
        projects: -1, // unlimited
        scansPerMonth: -1, // unlimited
        apiCallsPerDay: -1, // unlimited
        features: {
            bulkUpload: true,
            apiAccess: true,
            customSchedules: true,
            prioritySupport: true,
            whiteLabel: true,
            sso: true,
            onPremise: true,
            advancedCompliance: true,
            emailAlerts: true,
            historicalAnalysis: true,
        },
    },
};
exports.PLAN_PRICING = {
    [SubscriptionPlan.FREE]: {
        plan: SubscriptionPlan.FREE,
        name: 'Starter',
        monthlyPrice: 0,
        yearlyPrice: 0,
        currency: 'EUR',
        trialDays: 0,
    },
    [SubscriptionPlan.PROFESSIONAL]: {
        plan: SubscriptionPlan.PROFESSIONAL,
        name: 'Professional',
        monthlyPrice: 299,
        yearlyPrice: 2868, // 20% discount
        currency: 'EUR',
        trialDays: 14,
    },
    [SubscriptionPlan.ENTERPRISE]: {
        plan: SubscriptionPlan.ENTERPRISE,
        name: 'Enterprise',
        monthlyPrice: null,
        yearlyPrice: null,
        currency: 'EUR',
        trialDays: 30,
    },
};
